import Token from 'vindi-ds-tokens';

export default {
  iconBox: {
    marginTop: Token.padding.inset.micro.value,
  },
  checkCircleIcon: {
    color: Token.color.brand.secondary[500].value,
    marginRight: Token.padding.inset.xs.value,
    width: Token.padding.inset.small.value,
    height: Token.padding.inset.small.value,
  },
  advertsInfoBox: {
    display: 'flex',
    marginBottom: Token.padding.inset.medium.value,
  },
  infoBox: {
    marginBottom: Token.padding.squish.small.value,
  },
};
